<template>
	<ul class="flex-column">
		<li v-for="(item, i) in dataList" :key="i" class="flex-grow flex-center">
			<p :style="{'width': `${max.length}em`}">{{item.province_name}}</p>
			<div class="line flex-grow">
				<div :style="{'width': item.rate}"></div>
			</div>
			<div class="sum">
				<span :class="{'z-active': target == i}">￥{{item.money >= 10000 ? `${(item.money / 10000).toFixed(2)}万` : item.money}}</span>
			</div>
		</li>
	</ul>
</template>

<script>
	export default {
		data() {
			return {
				dataList: [],
				target: 0
			}
		},
		
		computed: {
			max() {
				let sum = 0, length = 0;
				this.dataList.forEach(item => {
					length = Math.max(item.province_name.length, length);
					sum = Math.max(item.money, sum);
				});
				return {length, sum};
			}
		},
		
		watch: {
			target: {
				handler(val) {
					setTimeout(() => {
						this.target = this.target == this.dataList.length - 1 ? 0 : this.target + 1
					}, 4000);
				},
				immediate: true
			}
		},

		methods: {
			update() {
				this.request({
					url: '/visual/data/region/sales',
					success: data => {
						setTimeout(() => {
							data.forEach(item => {
								this.$set(item, 'rate', `${item.money / this.max.sum * 100}%`);
							})
						}, this.dataList.length ? 0 : 100);
						this.dataList = data;
					}
				})
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.module {
		li {
			max-height: .4rem;
			padding-left: .2rem;
			font-size: .14rem;
			white-space: nowrap;
			color: #ABFFE9;
			
			.line {
				height: .06rem;
				border-radius: .03rem;
				margin-left: .16rem;
				background: rgba(255,255,255,.2);
				
				div {
					width: 0;
					height: 100%;
					border-radius: .03rem;
					transition: width 1s ease;
					background: linear-gradient(90deg, #00C365, #00FF4E);
				}
			}
			
			.sum {
				width: .75rem;
				
				span {
					display: inline-block;
					position: relative;
					border-radius: .04rem;
					padding: 0 .06rem;
					margin-left: .1rem;
					line-height: .24rem;
					font-size: .13rem;
					color: #000;
					background: #FFDC1A;
					opacity: 0;
					transition: opacity .3s ease;
					animation: sum 3s linear infinite;
					
					&.z-active {
						opacity: 1;
					}
					
					&:after {
						content: '';
						position: absolute;
						top: .07rem;
						left: -.04rem;
						border-right: .05rem solid #FFDC1A;
						border-top: .05rem solid rgba(0,0,0,0);
						border-bottom: .05rem solid rgba(0,0,0,0);
					}
				}
			}
		}
	}

	@keyframes sum {
		0% {
			transform: translate(0,0);
		}

		50% {
			transform: translate(.1rem,0);
		}

		100% {
			transform: translate(0,0);
		}
	}
</style>